import IconButton from '@material-ui/core/IconButton'
import makeStyles from '@material-ui/core/styles/makeStyles'
import clsx from 'clsx'
import React from 'react'
import { pxToRem } from '../Utilities/unitUtils'

const useStyles = makeStyles({
    borderedIconButton: {
        '&.MuiIconButton-root': {
            border: `1px solid `,
            padding: 8,
            boxSizing: 'border-box',
            borderRadius: (props: BorderedIconButtonProps) =>
                props.borderRadius,
            background: (props: BorderedIconButtonStyleProps) =>
                props.highlighted ? '#13B5EA' : 'none',
            borderColor: (props: BorderedIconButtonStyleProps) =>
                props.highlighted
                    ? 'rgba(255, 255, 255, 0.5)'
                    : 'rgba(255, 255, 255, 0.25)',

            '& .MuiSvgIcon-root': {
                fontSize: pxToRem(24),
            },
        },

        '&:hover': {
            background: (props: BorderedIconButtonStyleProps) =>
                props.highlighted ? '#13B5EA' : 'none',
            borderColor: (props: BorderedIconButtonStyleProps) =>
                props.highlighted
                    ? 'rgba(255, 255, 255, 0.5)'
                    : 'rgba(255, 255, 255, 0.25)',
        },
    },
})

export interface BorderedIconButtonStyleProps {
    /** Toggles highlight state on/off */
    highlighted: boolean
    /** Border radius */
    borderRadius?: string | number
}
export interface BorderedIconButtonProps
    extends Partial<BorderedIconButtonStyleProps> {
    /** Click event handler for button */
    onClick?: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void
    /** Optional class */
    className?: string
}

/**
 * Icon button with border and highlight state
 *
 */
const BorderedIconButton: React.FC<BorderedIconButtonProps> = ({
    highlighted = false,
    onClick,
    borderRadius = 2,
    className,
    children,
    ...rest
}) => {
    const classes = useStyles({ highlighted, borderRadius })
    return (
        <IconButton
            color="inherit"
            className={clsx(
                'borderedIconButton',
                classes.borderedIconButton,
                className
            )}
            onClick={onClick}
            {...rest}
        >
            {children}
        </IconButton>
    )
}

export default BorderedIconButton
